import cx from 'classnames'
import type { PropsWithChildren } from 'react'

import { inputWrapperStyles } from '../../forms/inputWrapper/inputWrapperStyles'
import { useTranslate } from '../../hooks/useTranslate'
import { Button } from './Button'

type Props = {
  isLoading?: boolean
  onReset?: () => void
  resetLabel?: string
}

export const FilterFormButtons = ({
  isLoading,
  onReset,
  resetLabel,
}: Props) => {
  const translate = useTranslate()
  return (
    <>
      {onReset && (
        <FakeInputWrapper>
          <Button variant="discreet" onClick={onReset}>
            {resetLabel ?? translate('filterFormButtons.reset')}
          </Button>
        </FakeInputWrapper>
      )}
      <FakeInputWrapper>
        <Button variant="primary" type="submit" isLoading={isLoading}>
          {translate('filterFormButtons.search')}
        </Button>
      </FakeInputWrapper>
    </>
  )
}

const FakeInputWrapper = (props: PropsWithChildren) => (
  <div className={cx(inputWrapperStyles())}>
    <span
      className="invisible pb-0.5" // since InputWrapper label has pb-0.5
    >
      &nbsp;
    </span>
    {props.children}
  </div>
)
